module.exports = function() {
  return new Worker("/" + "typescript-transpiler.edd003ee.worker.js");
};